"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tramonti-di-sopra": {
    "1dd84df5": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "chiarsuela": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2aab96a2": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "frasseneit": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e48405b3": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "pradiel": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9fd876eb": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "pradis-di-tramonti": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d8cb204b": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "quas": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c97ae0e6": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "redona": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db819031": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "selva": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "09de544d": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "staligial": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "39123262": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "tronconere": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2e00078c": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "valentinis": [{
      "hkey": "f8cb70ff",
      "slug": "tramonti-di-sopra",
      "name": "Tramonti di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;